var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-page-container"},[_c('div',{staticClass:"flex flex-grow justify-center pt-8 px-8"},[_c('CompanySelector')],1),_c('TheFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }